export default __webpack_public_path__ + "static/media/inversionboltenergy.ae083edf.svg";